import React, { Component } from "react";
import PropTypes from "prop-types";
import { FormControl } from "react-bootstrap";
import moment from "moment";

export class CampaignsVersionSelect extends Component {
  static propTypes = {
    handle: PropTypes.func.isRequired,
    campaign: PropTypes.object,
    currentVersionId: PropTypes.number.isRequired
  };

  handleChange(e) {
    if (this.props.handle) {
      this.props.handle(
        this.props.campaign.id,
        e.target.value
      );
    }
  }

  render() {
    if (!this.props.campaign) {
      return <div className="hide" />;
    }
    let versions = this.props.campaign.versions.sort((a, b) => b.id - a.id);
    let selected = "";
    let selectOptions = versions.map(version => {
      if (this.props.currentVersionId == version.id) {
        selected = "selected";
      } else {
        selected = "";
      }
      return (
        <option key={version.id} value={version.id} selected={selected}>
          {version.number}: {moment(version.created_at).format("MM/DD/YYYY")} -{" "}
          {version.status}{" "}
        </option>
      );
    }, this);
    return (
      <div className="campaigns_version_select">
        <FormControl
          componentClass="select"
          type="select"
          className="input"
          wrapperClassName="p-0"
          addonBefore={"Version"}
          name="version_id"
          onChange={this.handleChange.bind(this)}
        >
          {selectOptions}
        </FormControl>
      </div>
    );
  }
}

export default CampaignsVersionSelect;
